import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { cn } from "@/lib/utils/cn";
import { Card } from "./card";
import { uiKpi } from "./tokens";
export type StatTone = "neutral" | "accent" | "success" | "warning" | "error" | "info" | "offline" | "maintenance";
const toneClass: Record<StatTone, string> = {
  neutral: "",
  accent: "metric-card--solid",
  success: "metric-card--solid",
  warning: "metric-card--solid",
  error: "metric-card--solid",
  info: "metric-card--solid",
  offline: "metric-card--solid",
  maintenance: "metric-card--solid",
};

export type DataCardProps = {
  title: string;
  value: ReactNode;
  hint?: ReactNode;
  footer?: ReactNode;
  className?: string;
  tone?: StatTone;
};

export function DataCard({ title, value, hint, footer, className, tone = "neutral" }: DataCardProps) {
  return (
    <Card data-tone={tone} className={cn("metric-card flex h-full flex-col gap-ds-3", toneClass[tone], className)}>
      <p className={cn(uiKpi.label, "metric-card__label")}>{title}</p>
      <p className={cn(uiKpi.value, "metric-card__value")}><span className="metric-card__value-chip">{value}</span></p>
      {hint ? <p className={cn(uiKpi.hint, "metric-card__hint")}>{hint}</p> : null}
      {footer ? <div className="mt-auto border-t border-current/15 pt-ds-3">{footer}</div> : null}
    </Card>
  );
}

export type StatCardProps = {
  title: string;
  value: string;
  hint: string;
  href: string;
  className?: string;
  tone?: StatTone;
};

export function StatCard({ title, value, hint, href, className, tone }: StatCardProps) {
  return (
    <Link to={href} className={cn("group block rounded-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-canvas", className)}>
      <DataCard title={title} value={<span className="transition-opacity group-hover:opacity-90">{value}</span>} hint={hint} tone={tone} className="transition-[transform,border-color,box-shadow] group-hover:-translate-y-px group-hover:border-[var(--card-surface-border-strong)] group-hover:shadow-[var(--card-surface-shadow-hover)]" />
    </Link>
  );
}

export const StatPresentation = DataCard;
